angular.module('unica_track.track_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// TRACK
		.state('app.track', {
			url: '/track',
			abstract: true,
			views: {
				'mainContent': {
					templateUrl: './modules/track/templates/track.html',
					controller: 'TrackBasicController'
				}
			},
			params: {
				need_auth: true
			}
		})

			// TRACK LIST
			.state('app.track.list', {
				url: '/list/:event_id',
				views: {
					'trackContent': {
						templateUrl: './modules/track/templates/list.html',
						controller: 'TrackListController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Track',
					parent: function($scope) {
						return 'app.workshop.list({ event_id:' + $scope.event_id + ' })';
					}
				}
			})

			// TRACK CREATE
			.state('app.track.create', {
				url: '/create/:event_id',
				views: {
					'trackContent': {
						templateUrl: './modules/track/templates/create.html',
						controller: 'TrackCreateController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Crea Track',
					parent: 'app.track.list'
				}
			})

			// TRACK EDIT
			.state('app.track.edit', {
				url: '/edit/:event_id/:id',
				views: {
					'trackContent': {
						templateUrl: './modules/track/templates/edit.html',
						controller: 'TrackEditController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Modifica Track',
					parent: 'app.track.list'
				}
			});


});

